<template>
  <div ref="Steampunk" id="Steampunk" class="steampunk_animate_wrap">
    <video
        class="bg_video"
        :style="{width: `${defaultWidth}px`, height: `${defaultHeight}px`}"
        autoplay
        muted
        loop
    >
      <source :src="steampunkVideoBg" type="video/webm">
    </video>
    <div class="cpu_load_title_wrap">{{nowCpuLoad.type_label}}</div>
    <div class="cpu_load_text_wrap">
      <span class="value_label">{{nowCpuLoad.value_label}}</span>
      <span class="unit_label">{{nowCpuLoad.Unit}}</span>
    </div>
    <div class="cpu_fire_text_wrap">
      <span class="value_label">{{nowCPUPower.value_label}}</span>
      <span class="unit_label">{{nowCPUPower.Unit}}</span>
    </div>
    <div class="cpu_temp_text_wrap">
      <span class="value_label">{{nowCpuTemp.value_label}}</span>
      <span class="unit_label">{{nowCpuTemp.Unit}}</span>
    </div>
    <div class="date_text_wrap">
      <span class="date_label">{{nowDateTimeObj.obj.date}}</span>
      <span class="year_label">{{nowDateTimeObj.obj.y}}</span>
    </div>
    <div class="time_text_wrap">{{nowDateTimeObj.obj.time}}</div>
  </div>
</template>

<script setup>
import steampunkVideoBg from '@/assets/steampunk/steampunk_video_bg.webm'
import defaultValue from "@/utils/defaultValue"
import {onMounted, onUnmounted, reactive, ref, watch} from "vue";
import moment from "moment";

const {defaultWidth, defaultHeight} = defaultValue()

const props = defineProps(['sensorValue'])
const nowCpuTemp = reactive({
  type_label: 'CPU TEMP',
  value_label: '--',
  Unit: '°F'
})
const nowCpuLoad = reactive({
  type_label: 'CPU',
  value_label: '--',
  Unit: '%'
})
const nowCPUPower = reactive({
  type_label: 'POWER',
  value_label: '--',
  Unit: 'W'
})

let nowDateTimeObj = reactive({obj: {}})
let timeTiger = ref(null)
const startTime = () => {
  if (timeTiger.value) clearTimeout(timeTiger.value)
  const nowDate = moment().format('YYYY,MM/DD,HH:mm').split(',')
  const timeTextObj = {
    y: nowDate[0],
    date: nowDate[1],
    time: nowDate[2], // 時間
  }
  nowDateTimeObj.obj = timeTextObj
  timeTiger.value = setTimeout(function () {
    startTime()
  }, 150)
}


watch(
    props.sensorValue,
    (n) => {
      if (n) {
        const {
          CPULoad,
          CPUTemperature,
          CPUPower
        } = n
        if (CPULoad && Object.keys(CPULoad).length > 0) {
          Object.assign(nowCpuLoad, CPULoad, {
            type_label: `${CPULoad.Type}`,
            value_label: parseInt(CPULoad.Value) > 0 ? CPULoad.Value : '--'
          })
        }
        if (CPUTemperature && Object.keys(CPUTemperature).length > 0) {
          Object.assign(nowCpuTemp, CPUTemperature, {
            type_label: `${CPUTemperature.Type}`,
            value_label: parseInt(CPUTemperature.Value) > 0 ? CPUTemperature.Value : '--'
          })
        }
        if (CPUPower && Object.keys(CPUPower).length > 0) {
          Object.assign(nowCPUPower, CPUPower, {
            type_label: `${CPUPower.Type}`,
            value_label: parseInt(CPUPower.Value) > 0 ? CPUPower.Value : '--'
          })
        }
      }
    },
    {immediate: true}
)

onMounted(() => {
  startTime()
})

onUnmounted(() => {
  if (timeTiger.value) clearTimeout(timeTiger.value)
})
</script>

<style lang="scss">
@import "src/assets/scss/font-family";

.steampunk_animate_wrap {
  position: relative;
  .bg_video {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .cpu_load_title_wrap {
    position: absolute;
    top: 90px;
    left: 168px;
    font-family: HyperspaceRace_BoldItalic;
    font-size: 32px;
    color: #EAB172;
    line-height: 1;
    text-align: center;
    width: 150px;
    text-shadow: 0px 0px 5px #000000;
  }
  .cpu_load_text_wrap {
    position: absolute;
    top: 106px;
    left: 135px;
    font-family: HyperspaceRace_BoldItalic;
    width: 220px;
    .value_label {
      display: inline-block;
      min-width: 180px;
      font-size: 120px;
      color: #F5F5F5;
      line-height: 1;
      text-align: center;
      text-shadow: 0px 0px 6px #000000;
    }
    .unit_label {
      font-size: 40px;
      color: #F5F5F5;
      line-height: 1;
      text-shadow: 0px 0px 6px #000000;
    }
  }
  .cpu_fire_text_wrap {
    position: absolute;
    top: 236px;
    left: 206px;
    font-family: HyperspaceRace_BoldItalic;
    width: 124px;
    .value_label {
      display: inline-block;
      font-size: 33px;
      min-width: 84px;
      color: #EAB172;
      line-height: 1;
      text-align: center;
    }
    .unit_label {
      font-size: 33px;
      color: #EAB172;
      line-height: 1;
      padding-left: 4px;
    }
  }
  .cpu_temp_text_wrap {
    position: absolute;
    top: 280px;
    left: 224px;
    font-family: HyperspaceRace_BoldItalic;
    width: 100px;
    .value_label {
      display: inline-block;
      font-size: 33px;
      min-width: 60px;
      color: #EAB172;
      line-height: 1;
      text-align: center;
      text-shadow: 0px 0px 6px #000000;
    }

    .unit_label {
      font-size: 33px;
      color: #EAB172;
      line-height: 1;
      padding-left: 4px;
      text-shadow: 0px 0px 6px #000000;
    }
  }
  .date_text_wrap {
    position: absolute;
    top: 402px;
    left: 137px;
    font-family: HyperspaceRace_BoldItalic;
    width: 68px;
    .date_label {
      display: block;
      font-size: 24px;
      line-height: 1;
      color: #FFBC39;
      text-align: left;
      text-shadow: 3px 4px 80px #000000;
    }
    .year_label {
      display: block;
      font-size: 24px;
      line-height: 1;
      color: #FFBC39;
      text-align: left;
      text-shadow: 3px 4px 80px #000000;
    }
  }
  .time_text_wrap {
    position: absolute;
    top: 395px;
    left: 210px;
    font-family: HyperspaceRace_BoldItalic;
    font-size: 55px;
    line-height: 1;
    color: #FFFFFF;
    text-align: center;
    width: 142px;
    text-shadow: 0px 3px 6px #000000;
  }
}
</style>
